import styled from 'styled-components';
import Icon from '@minecraft.icon';
import { media } from '@minecraft.themes';

// Start Common Styles

export const SectionTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`;

export const SectionTitleIcon = styled(Icon)`
  height: 1rem;
  width: 1rem;
  margin-right: 0.375rem;
  flex-shrink: 0;
`;

export const SectionTitleWithIcon = styled(SectionTitle)`
  display: flex;
  align-items: center;
`;

// End Common Styles

export const SummaryContainer = styled.div`
  ${media.md`
    display: flex;
    flex-direction: row;
  `}
`;

export const SummaryPrimaryPhotoWrapper = styled.div`
  flex: 0 0 auto;

  & img {
    box-shadow: inset 0px 0px 0px 0.0625rem ${(props): string => props.theme.colors.primary.ltGrey1};
    max-width: 100%;
  }
`;

export const SummaryInfo = styled.div`
  flex: 1;
  margin-top: 2rem;

  ${media.md`
    margin-top: 0;
    margin-left: 2rem;
  `}
`;

export const SummaryInfoItem = styled.div`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`;

export const SummaryInfoItemInner = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

export const SummaryPickWrapper = styled.div`
  background-color: ${(props): string => props.theme.colors.primary.ltGrey2};
  border: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
`;

export const SummaryPickHelperTextWrapper = styled.div`
  border-bottom: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
  padding: 1rem 1rem 0 1rem;
`;

export const PicksWrapperWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem;
`;
